import { apiRequest } from "@/lib/api-client";
import { MOCK_API } from "@/lib/constants";
import {
  mockGetLoginMethods,
  mockGetMe,
} from "@/lib/mock/store";
import type { LoginMethods, SSOLoginResponse, User } from "@/types";

export async function getLoginMethods(): Promise<LoginMethods> {
  if (MOCK_API) return mockGetLoginMethods();
  return apiRequest<LoginMethods>("/api/auth/login-methods", { auth: false });
}

/**
 * Nexus portal login URL with `returnUrl` set to this app's `/sso-callback`
 * so a successful SSO round-trip lands back here with the access token.
 */
export function buildNexusLoginUrl(nexusLoginUrl: string): string {
  const url = new URL(nexusLoginUrl);
  url.searchParams.set("returnUrl", `${window.location.origin}/sso-callback`);
  return url.toString();
}

export async function loginWithSSO(token: string): Promise<SSOLoginResponse> {
  if (MOCK_API) {
    throw new Error("SSO is disabled in mock mode — use the mock login buttons");
  }
  return apiRequest<SSOLoginResponse>("/api/auth/sso/login", {
    method: "POST",
    auth: false,
    body: { token },
  });
}

export async function getMe(): Promise<User> {
  if (MOCK_API) return mockGetMe();
  return apiRequest<User>("/api/auth/me");
}
